var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.button.type === "url"
    ? _c(
        "a",
        {
          attrs: { href: _vm.button.url },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onUrlButtonClick.apply(null, arguments)
            },
          },
        },
        [
          _c("button", { class: _vm.classes, attrs: { type: "button" } }, [
            _vm._v("\n    " + _vm._s(_vm.button.title) + "\n  "),
          ]),
        ]
      )
    : _vm.isNonUrlButtonType
    ? _c(
        "button",
        {
          class: _vm.classes,
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.submitButton()
            },
          },
        },
        [
          _c("div", { staticClass: "quick-reply-button__container" }, [
            _c("div", { staticClass: "quick-reply-button__container__text" }, [
              _vm._v(_vm._s(_vm.button.title)),
            ]),
            _vm._v(" "),
            _vm.button.isDisabled
              ? _c(
                  "div",
                  { staticClass: "quick-reply-button__container__icon" },
                  [_c("info-icon")],
                  1
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }